<template>
    <div v-if="collectivePage" class="collective">
        <section
            v-if="
                collectivePage.VideoPageCover &&
                collectivePage.VideoPageCover.VideoUrl
            "
            class="embed-container"
        >
            <iframe
                :src="collectivePage.VideoPageCover.VideoUrl"
                frameborder="0"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
            ></iframe>
            <div class="translucent-gr"></div>
            <div class="md:container mx-auto px-4 md:px-8 lg:px-12">
                <div class="content">
                    <h1
                        class="text-white text-center text-2xl lg:text-7xl font-semibold leading-snug"
                        v-text="collectivePage.VideoPageCover.Title"
                    ></h1>
                </div>
            </div>
        </section>
        <section v-if="collectivePage.BodyText.Description" class="section-bg">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <div class="text-center">
                    <rich-text :text="collectivePage.BodyText.Description" />
                </div>
                <div
                    v-if="collectivePage.BodyText.ButtonUrl"
                    class="text-center mt-8"
                >
                    <nuxt-link :to="collectivePage.BodyText.ButtonUrl"
                        ><button class="btn btn-primary btn-arrow">
                            {{ collectivePage.BodyText.ButtonText }}
                        </button></nuxt-link
                    >
                </div>
            </div>
        </section>
        <div
            v-if="
                collectivePage.Collectives &&
                collectivePage.Collectives.length > 0
            "
            class="py-4 md:py-6 lg:py-12"
        >
            <div
                v-for="(info, index) in collectivePage.Collectives"
                :key="index"
            >
                <section v-if="index % 2 === 0">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-4 md:py-6 lg:py-12"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                            :flip="false"
                        />
                    </div>
                </section>
                <section v-if="index % 2 === 1">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-4 md:py-6 lg:py-12"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :flip="true"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                        />
                    </div>
                </section>
            </div>
        </div>
        <section v-if="collectivePage.OtherDetails" class="section-bg">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <div class="text-center">
                    <rich-text :text="collectivePage.OtherDetails" />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const { data: collectivePage } = await useFetch(
    config.public.baseURl + '/the-collective-page'
);
useHead({
    title: 'The Collective',
});
</script>

<style lang="scss" scoped>
.collective {
    .embed-container {
        position: relative;
        height: calc(100vh - 80px - 150px);
        overflow: hidden;
        max-width: 100%;
        iframe {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            aspect-ratio: 4 / 3;
        }
        .content {
            position: absolute;
            bottom: 24px;
            left: 0;
            z-index: 2;
            width: 100%;
        }
        @media (max-width: 767px),
            (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
            height: 200px;
            iframe {
                aspect-ratio: none;
            }
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
            height: 395px;
            iframe {
                aspect-ratio: none;
            }
        }
    }
}
</style>
